<template>
	<div class="btn-group dropdown-mod" :class="{ show: show }" @click="toggle">
	  	<div class="dropdown-btn" ref="dropdownBtn" @blur="onBlur" tabindex="1"><slot name="buttom"></slot></div>
	    <slot :class="{ show: show }"></slot>
	</div>
</template>

<script>
	export default {
		name: 'dropdown',
		methods: {
			toggle () {
				this.show = !this.show
				if (this.show) {
					this.$refs.dropdownBtn.focus()
				} else {
					this.$refs.dropdownBtn.blur()
				}
			},
			onBlur () {
				this.show = false
			}
		},
		data () {
			return {
				show: false
			}
		}
	}
</script>

<style lang="scss">
.dropdown-mod.show .dropdown-menu {
	display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/dropdown/dropdown.vue